import { Omit } from '@40seas/entities/common';
import { ChargeReconciliation } from '@40seas/entities/charges';

export class ChargeReconciliationQueryDto extends Omit(ChargeReconciliation, ['buyerLegalName', 'revenue']) {}
